export default "__VITE_ASSET__d683467e__"